import { createApp } from "vue";
import App from "./App.vue";
import "./style.scss";
import router from "./core/router";
import { i18n, setAppLocale } from "@/i18n";
import { createPinia } from "pinia";
import { abilitiesPlugin } from "@casl/vue";
import { appAbility, useAuthStore } from "@/domains/auth";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import ganttastic from "@infectoone/vue-ganttastic";
import posthog from "posthog-js";
import { scrubPostHogEvent } from "@/infrastructure/analytics/posthog-sanitizer";

// Configuración de PostHog
posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
  api_host: process.env.VUE_APP_POSTHOG_HOST || "https://us.i.posthog.com",
  defaults: "2025-05-24",
  person_profiles: "identified_only",
  before_send: scrubPostHogEvent,
});

// Configuración de vue-toastification (opcional)
const toastOptions = {
  position: "bottom-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

// Crea la aplicación de Vue
const app = createApp(App);

// Captura errores no manejados de Vue en PostHog
app.config.errorHandler = (err) => {
  posthog.captureException(err);
};

(async () => {
  const pinia = createPinia();
  app.use(pinia);

  if (router.resolve(window.location.pathname).meta.routeException !== "public_itinerary_review") {
    const authStore = useAuthStore();
    await authStore.initialize();
    setAppLocale(authStore.user?.preferred_language);
  }

  app.use(abilitiesPlugin, appAbility, { useGlobalGuard: false });
  app.use(router);
  app.use(Toast, toastOptions);
  app.use(i18n);
  app.use(VCalendar, {});
  app.use(ganttastic);

  app.mount("#app");
})();
